// extracted by mini-css-extract-plugin
export default {"filter-panel":"FilterPanel_filter-panel__vRY6O","group":"FilterPanel_group__St1Wn","label":"FilterPanel_label__JKjwc","groupLabel":"FilterPanel_groupLabel__rU0vV"};